import { ChevronDown, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';
import type { AgentSummary } from 'features/chat/agent-chat-module/types/agent.service.type';

type AgentDetailsNavHeaderProps = {
  agentName: string;
  agents?: AgentSummary[];
  isLoading?: boolean;
  onAgentSelect?: (agentId: string) => void;
  onBack?: () => void;
  className?: string;
};

export function AgentDetailsNavHeader({
  agentName,
  agents = [],
  isLoading = false,
  onAgentSelect,
  onBack,
  className,
}: AgentDetailsNavHeaderProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={cn('flex items-center gap-2 rounded-2xl', className)}>
        <Skeleton className="size-5 shrink-0 rounded-sm" />
        <Skeleton className="h-[22px] w-40 max-w-[12rem]" />
        <Skeleton className="size-4 shrink-0 rounded-sm" />
      </div>
    );
  }

  return (
    <div className={cn('flex min-w-0 items-center gap-2 rounded-2xl', className)}>
      <button
        type="button"
        onClick={onBack}
        className="flex size-5 shrink-0 items-center justify-center text-[#27272C] transition-opacity hover:opacity-70 dark:text-foreground"
        aria-label={t('BACK') || 'Back'}
      >
        <ChevronLeft className="size-5" strokeWidth={1.75} />
      </button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            onClick={onBack}
            className="flex min-w-0 max-w-full items-center gap-2 rounded-2xl text-left outline-none transition-opacity hover:opacity-80 focus-visible:ring-1 focus-visible:ring-ring"
          >
            <span className="truncate text-sm font-medium leading-[1.6] text-[#27272C] dark:text-foreground">
              {agentName}
            </span>
            {/* <ChevronDown className="size-4 shrink-0 text-[#27272C] dark:text-foreground" strokeWidth={1.75} /> */}
          </button>
        </DropdownMenuTrigger>
        {/* <DropdownMenuContent align="start" className="max-h-64 w-56 overflow-y-auto">
          {agents.length > 0 ? (
            agents.map((item) => (
              <DropdownMenuItem
                key={item.id}
                onClick={() => onAgentSelect?.(item.id)}
                className="truncate"
              >
                {item.name || t('UNTITLED_AGENT') || 'Untitled Agent'}
              </DropdownMenuItem>
            ))
          ) : (
            <DropdownMenuItem disabled>{agentName}</DropdownMenuItem>
          )}
        </DropdownMenuContent> */}
      </DropdownMenu>
    </div>
  );
}
